
import Main from "layouts/Main";


function ChatPage() {

  return (
    <>
    <Main namePage="แชต"  >
      <div className="layout-content">
        <h1> Comming Soon ..... </h1>
      </div>
      </Main>
    </>
  );
}

export default ChatPage;